import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { AdTopBanner, AdInContent, AdBottomBanner } from '../components/AdSense';

const PregnancyConceptionCalculatorPage = () => {
  const [calcMode, setCalcMode] = useState('dueDate');
  const [dueDate, setDueDate] = useState('');
  const [lmpDate, setLmpDate] = useState('');
  const [cycleLength, setCycleLength] = useState('28');
  const [result, setResult] = useState(null);

  const addDays = (date, days) => { const r = new Date(date); r.setDate(r.getDate() + days); return r; };
  const formatDate = (date) => date.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });

  const calculate = () => {
    const cycle = parseInt(cycleLength) || 28;
    const ovulationDay = cycle - 14;
    let conception, fertileStart, fertileEnd;

    if (calcMode === 'dueDate' && dueDate) {
      const due = new Date(dueDate);
      const lmp = addDays(due, -280);
      conception = addDays(lmp, ovulationDay);
      fertileStart = addDays(conception, -5);
      fertileEnd = addDays(conception, 1);
      setResult({ conception, fertileStart, fertileEnd, lmp, dueDate: due });
    } else if (calcMode === 'lmp' && lmpDate) {
      const lmp = new Date(lmpDate);
      conception = addDays(lmp, ovulationDay);
      fertileStart = addDays(conception, -5);
      fertileEnd = addDays(conception, 1);
      const due = addDays(lmp, 280);
      setResult({ conception, fertileStart, fertileEnd, lmp, dueDate: due });
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <AdTopBanner />
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link><span className="mx-2">›</span>
            <span className="text-gray-400">Pregnancy Conception Calculator</span>
          </nav>
          <h1 className="text-3xl font-bold text-white mb-4">Pregnancy Conception Calculator</h1>
          <p className="text-gray-400 mb-6">Estimate when conception occurred and your fertile window.</p>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
            <div className="flex border-b border-[#2a2a2a] mb-6">
              <button onClick={() => setCalcMode('dueDate')}
                className={`px-4 py-2 text-sm border-b-2 ${calcMode === 'dueDate' ? 'border-cyan-500 text-cyan-400' : 'border-transparent text-gray-400'}`}>From Due Date</button>
              <button onClick={() => setCalcMode('lmp')}
                className={`px-4 py-2 text-sm border-b-2 ${calcMode === 'lmp' ? 'border-cyan-500 text-cyan-400' : 'border-transparent text-gray-400'}`}>From Last Period</button>
            </div>

            <div className="space-y-4">
              {calcMode === 'dueDate' ? (
                <div className="flex flex-wrap items-center gap-4">
                  <label className="text-gray-300 w-32">Due Date</label>
                  <Input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)}
                    className="w-48 bg-[#0d0d0d] border-[#2a2a2a] text-white" />
                </div>
              ) : (
                <div className="flex flex-wrap items-center gap-4">
                  <label className="text-gray-300 w-32">Last Period</label>
                  <Input type="date" value={lmpDate} onChange={(e) => setLmpDate(e.target.value)}
                    className="w-48 bg-[#0d0d0d] border-[#2a2a2a] text-white" />
                </div>
              )}
              <div className="flex flex-wrap items-center gap-4">
                <label className="text-gray-300 w-32">Cycle Length</label>
                <Input type="number" value={cycleLength} onChange={(e) => setCycleLength(e.target.value)}
                  className="w-20 bg-[#0d0d0d] border-[#2a2a2a] text-white" />
                <span className="text-gray-400">days</span>
              </div>
            </div>
            <Button onClick={calculate} className="mt-6 bg-cyan-600 hover:bg-cyan-500 text-white px-8">Calculate</Button>

            {result && (
              <div className="mt-6 p-5 bg-[#0d0d0d] border border-[#2a2a2a] rounded-xl">
                <div className="text-center mb-6">
                  <p className="text-gray-400 mb-2">Estimated Conception Date</p>
                  <p className="text-3xl font-bold text-green-400">{formatDate(result.conception)}</p>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="p-4 bg-[#1a1a1a] rounded-lg">
                    <p className="text-gray-400 text-sm mb-2">Fertile Window</p>
                    <p className="text-white font-medium">{formatDate(result.fertileStart)} - {formatDate(result.fertileEnd)}</p>
                  </div>
                  <div className="p-4 bg-[#1a1a1a] rounded-lg">
                    <p className="text-gray-400 text-sm mb-2">Due Date</p>
                    <p className="text-white font-medium">{formatDate(result.dueDate)}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <AdInContent />
          <div className="mt-6 flex flex-wrap gap-2 text-sm">
            <span className="text-gray-500">Related:</span>
            <Link to="/pregnancy-calculator" className="text-cyan-400 hover:text-cyan-300">Pregnancy Calculator</Link>
            <span className="text-gray-600">|</span>
            <Link to="/due-date-calculator" className="text-cyan-400 hover:text-cyan-300">Due Date Calculator</Link>
          </div>
          <AdBottomBanner />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PregnancyConceptionCalculatorPage;
